import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve si mi hijo tiene menos de 6 meses?',
  answer: 'Es ideal para eso. El Tomo 1 está diseñado específicamente para los primeros 6 meses de vida, que son la etapa más crítica del neurodesarrollo. Cuanto antes empezás, más aprovechás la ventana de neuroplasticidad del cerebro de tu hijo.'
}, {
  question: '¿Los materiales son imprimibles?',
  answer: 'Sí. Todos los checklists, registros de progreso, flashcards y material de actividades están en formato PDF listo para imprimir o usar en pantalla. Podés tenerlos siempre a mano cuando los necesites.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos opciones?',
  answer: 'Los 6 bonos están incluidos en las dos opciones. Si además querés el protocolo avanzado de neurodesarrollo con seguimiento semana a semana y registro ampliado, el Megapack Completo es la opción más inteligente.'
}, {
  question: '¿Necesito conocimientos previos para usarlo?',
  answer: 'No. Todo está explicado en lenguaje claro y accesible para cualquier mamá, sin tecnicismos innecesarios. Cada actividad viene con instrucciones paso a paso y el material fue revisado por profesionales de estimulación temprana, kinesiología y fonoaudiología.'
}, {
  question: '¿Funciona para cualquier etapa entre 0 y 36 meses?',
  answer: 'Sí. Los 6 tomos cubren todas las etapas desde los primeros días de vida hasta los 3 años, con actividades organizadas mes a mes por área de desarrollo: motriz, lenguaje, cognitiva y socioemocional.'
}, {
  question: '¿Qué hago si veo una alerta en el semáforo?',
  answer: 'El semáforo de alertas te indica qué señales requieren consulta profesional y cuáles son parte del desarrollo normal. No reemplaza al pediatra — te da criterio para saber cuándo actuar y cuándo esperar, sin angustiarte innecesariamente.'
}, {
  question: '¿Qué diferencia tiene con los videos y posts de estimulación que hay en internet?',
  answer: 'El contenido gratuito de internet es disperso, sin orden y sin criterio clínico. El Megapack es un sistema organizado mes a mes, área por área, con alertas, checklists y registros de progreso. No es información suelta — es una hoja de ruta completa para los primeros 3 años.'
}, {
  question: '¿Por qué elegir el Megapack Completo y no el estándar?',
  answer: 'El Megapack base te da el sistema completo de 0 a 36 meses con todo lo necesario para estimular bien a tu hijo. El Completo agrega el protocolo avanzado de neurodesarrollo: planificación semanal, registro ampliado y guiones de comunicación verbal para potenciar al máximo cada etapa.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(243,232,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(243,232,255) 100%)'
  }} data-id="element-139">
      <div className="mx-auto max-w-4xl" data-id="element-140">
        {/* ── HEADING ── */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-141">
          Preguntas{' '}
          <span style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-142">
            frecuentes
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-143">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* ── ACCORDION ── */}
        <div className="flex flex-col gap-2" data-id="element-144">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(168,85,247,0.50)' : '1px solid rgba(168,85,247,0.15)'
          }} data-id="element-145">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-146">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#7c3aed' : '#111827'
              }} data-id="element-147">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-148">
                    +
                  </span>
                </button>

                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(168,85,247,0.10)'
            }} data-id="element-149">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-150">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}